import React from "react"
import * as S from "./custom-checkbox.styles"

const CustomCheckbox = ({
  name,
  label,
  register,
  defaultChecked,
  validate,
  value,
}) => {
  return (
    <S.OptionWrapper
      control={
        <S.CustomCheckbox
          defaultChecked={defaultChecked}
          value={value}
          name={name}
          inputRef={register({
            required: false,
            validate: validate,
          })}
        />
      }
      label={label}
    />
  )
}

export default CustomCheckbox
